// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { getSubdomain } from '@/utils/subdomain';

export interface OrgBranding {
  org_id: string;
  org_name: string;
  logo_url: string | null;
  is_recruitlook_branded: boolean;
  website: string | null;
  subdomain: string | null;
}

// Resolves the site-wide org branding from the current subdomain (white-label
// groundwork). Returns null on the apex domain / local / preview, so the app
// falls back to default RecruitLook branding. Wired now; only activates once
// wildcard DNS routes org subdomains here.
export function useSubdomainBranding() {
  const subdomain = getSubdomain();

  const { data, isLoading } = useQuery<OrgBranding | null>({
    queryKey: ['subdomain-branding', subdomain],
    enabled: !!subdomain,
    staleTime: 1000 * 60 * 10,
    queryFn: async () => {
      if (!subdomain) return null;
      const { data, error } = await supabase.rpc('get_org_by_subdomain', {
        p_subdomain: subdomain,
      });
      if (error) {
        console.warn('useSubdomainBranding: RPC failed', error);
        return null;
      }
      const org = Array.isArray(data) ? data[0] : data;
      if (!org) return null;
      return {
        org_id: org.id,
        org_name: org.name,
        logo_url: org.logo_url ?? null,
        is_recruitlook_branded: org.is_recruitlook_branded ?? true,
        website: org.website ?? null,
        subdomain,
      };
    },
  });

  return { branding: data ?? null, isLoading, subdomain };
}
